module.exports = __webpack_public_path__ + "img/documentation.1d8f65ca.svg";